import styled from 'styled-components';

export enum IndicatorStatus {
	NEUTRAL = 'NEUTRAL',
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE',
	INFO = 'INFO',
	NONE = 'NONE'
}

// todo: change css variables to be general ones instead of having betslip context
export const BulletIndicator = styled.div<{ indicatorStatus: IndicatorStatus }>`
	/* position: absolute;
	right: -3.5px;
	top: 4.5px; */
	height: 7px;
	width: 7px;
	border-radius: 50%;
	/* z-index: 1; */

	${({ indicatorStatus }) => {
		switch (indicatorStatus) {
			case IndicatorStatus.NEUTRAL:
				return `background-color: var(
			--sportsbook-connection-border-color,
			rgba(var(--base-03), 1)
		);`;
			case IndicatorStatus.SUCCESS:
				return `background-color: var(
			--sportsbook-betslip-placement-state-color-placed);`;
			case IndicatorStatus.FAILURE:
				return `background-color: var(
			--sportsbook-betslip-placement-state-color-declined);`;
			case IndicatorStatus.INFO:
				return `background-color: var(
				--sportsbook-betslip-placement-state-color-new-offer);`;
			default:
				return 'display: none;';
		}
	}}
`;
